import React from 'react'
import { WhenModelValue } from '@morningtrain/react-resources'
import * as Icons from 'ui/icons'

function OnboardingStatusField (props) {
  const {
    fulfilledFieldName,
  } = props

  return (
    <div>
      <div>
        <WhenModelValue name={fulfilledFieldName} condition={null} negate>
          <Icons.CheckmarkCircle className='w-4 h-4 text-primary-500'/>
        </WhenModelValue>
        <WhenModelValue name={fulfilledFieldName} condition={null}>
          <Icons.CheckmarkCircle className='w-4 h-4'/>
        </WhenModelValue>
      </div>
    </div>
  )
}

export default OnboardingStatusField
